<nf-grid-wrapper
  [gridApi]="gridApi?.api"
  [hideClearAll]="true"
  [hideSearch]="true"
  role="group"
  attr.aria-label="Breaks & Variances"
>
  <nf-grid-wrapper-header-left>
    <h2 class="title">Breaks & Variances</h2>
  </nf-grid-wrapper-header-left>

  <ng-grid-wrapper-header-right *ngIf="isJobCompleted">
    <button
      nf-icon-button
      icon="reload-alert"
      class="btn-bare reload-alert text-danger refresh-grid"
      ngbTooltip="Refresh the Breaks & Variances table"
      label="Reload Alert"
      (click)="onRefreshGrid()"
      placement="bottom"
    >
      Reload Alert
    </button>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <nf-form-control compact class="form-class">
      <input
        type="text"
        class="form-control"
        placeholder="Search Table..."
        [formControl]="searchText"
      />
    </nf-form-control>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <button
      *ngIf="hasFindCurrentSessionFeature"
      nf-button
      ngbTooltip="Search the Breaks & Variances table for the current session"
      placement="bottom-right"
      id="currentSessionFindBreaks"
      (click)="onSearchCurrentSession()"
      [disabled]="!hasActiveSession || isInCurrentSession"
    >
      Current Session
    </button>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right>
    <button
      *ngIf="hasFindBreaksFeature"
      nf-button="primary"
      ngbTooltip="Search for breaks to Download"
      placement="auto"
      (click)="onSearchClicked(fetchPopover)"
      #fetchPopover="ngbPopover"
      [ngbPopover]="popoverContent"
      autoClose="outside"
      container="body"
      popoverClass="find-multi-breaks-popover"
    >
      Find Breaks
    </button>
    <ng-template #popoverContent>
      <ng-content></ng-content>
    </ng-template>
  </ng-grid-wrapper-header-right>

  <ng-grid-wrapper-header-right>
    <div ngbDropdown placement="bottom-right">
      <button
        ngbDropdownToggle
        nf-icon-button
        class="breaks-actions-button"
        ngbTooltip="Breaks Actions"
        placement="bottom-right"
        icon="dots-vertical"
      >
        Breaks Actions
      </button>
      <div
        ngbDropdownMenu
        aria-labelledby="dropdown"
        class="dropdown-menu dropdown-menu-right"
      >
        <button
          type="button"
          class="dropdown-item btn btn-link"
          (click)="exportBreaksToExcel()"
        >
          Export to Excel
        </button>
      </div>
    </div>
  </ng-grid-wrapper-header-right>

  <ng-grid-wrapper-header-right>
    <button
      id="clear-all-filters-button"
      nf-icon-button="secondary"
      ngbTooltip="Clear Filters"
      icon="filter-remove"
      (click)="clearFilters()"
      class="filter-button"
      [disabled]="!clearFiltersEnabled"
      placement="bottom-right"
    >
      Clear All Filters
    </button>
    <hs-applied-filter-counts
      [filterCount]="filterCount"
    ></hs-applied-filter-counts>
  </ng-grid-wrapper-header-right>
  <nf-grid-wrapper-content
    id="breaks-limit-exceeded-alert"
    *ngIf="(totalFocusedBreaks ?? 0) > MAX_BREAKS || breaksLimitExceeded"
  >
    <ngb-alert [dismissible]="false">
      <strong>Data may be incomplete!</strong> More than 10,000 breaks found,
      narrow down your search to receive the complete list.
    </ngb-alert>
  </nf-grid-wrapper-content>
  <nf-grid-wrapper-content *ngIf="gridOptions$ | async as gridOptions">
    <nf-table-layout
      #table
      class="breaks-table-layout"
      [gridOptions]="gridOptions"
      [modules]="gridModules"
      [data]="data"
      [autoResizeGrid]="false"
      hideSearch
      hideClearAll
      hideTitle
      *nfLoader="isLoading"
    >
    </nf-table-layout>
  </nf-grid-wrapper-content>
</nf-grid-wrapper>
